import(/* webpackMode: "eager", webpackExports: ["FavoritesView"] */ "/var/www/crimerussia.com/src/views/favorites/FavoritesView.tsx");
